var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('the-breadcrumbs'),_c('page-content',{attrs:{"page-title":"Neue Region"}},[_c('region-form',{attrs:{"region":_vm.region,"submit-label":"Neue Region anlegen","form-submitted":_vm.saveRegion,"mode":"new"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }